/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const Number6SansDark = () => (
	<>
		<path
			fill={'#0D2A5E'}
			d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
		/>
		<path
			fill="white"
			d="M16.99 7.38C19.02 7.38 20.72 8.07999 21.92 9.10999L20.32 11.79C19.42 10.94 18.47 10.46 16.99 10.46C14.46 10.46 12.81 12.64 12.81 15.29C12.81 15.42 12.81 15.54 12.84 15.64C13.62 14.51 15.29 13.51 17.12 13.51C20.12 13.51 22.8 15.34 22.8 18.89C22.8 22.14 20.22 24.62 16.42 24.62C11.34 24.62 9.20999 20.71 9.20999 16.01C9.20999 10.95 12.06 7.37 17 7.37L16.99 7.38ZM16.09 16.46C14.84 16.46 13.64 17.09 12.84 18.06C12.99 19.66 13.89 21.52 16.24 21.52C18.17 21.52 19.19 20.22 19.19 19.04C19.19 17.24 17.71 16.46 16.09 16.46Z"
		/>
	</>
);

export default Number6SansDark;
